import { PickDomain } from '../../../../shared/utilities/types/PickDomain';
import { Agency } from '../types/Agency';

export function sortedAgenciesByBetterTripIndex<A extends PickDomain<Agency, 'betterTripIndex'>>(
    agencies: Array<A>,
) {
    return [...agencies].sort((agencyA, agencyB) => {
        const order = { STAR: 0, A: 1, B: 2, NEW: 2, NONE: 2, C: 3, 'NO BTI': 3 };
        return order[agencyA.betterTripIndex] - order[agencyB.betterTripIndex];
    });
}
